import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, isRef as _isRef } from "vue";
import _imports_0 from '@/assets/images/activity/sharing_process.png';
import _imports_1 from '@/assets/images/activity/how_to_get_1.png';
import _imports_2 from '@/assets/images/activity/how_to_get_2.png';
import _imports_3 from '@/assets/images/activity/how_to_get_3.png';
var _hoisted_1 = {
  class: "h-full"
};
var _hoisted_2 = {
  key: 0,
  class: "sharing-process"
};
var _hoisted_3 = {
  class: "flex items-center flex-col"
};
var _hoisted_4 = {
  class: "content-wrap"
};
var _hoisted_5 = {
  class: "title absolute-center-x"
};
var _hoisted_6 = {
  class: "coupon-price-wrap"
};
var _hoisted_7 = {
  class: "coupon-countdown"
};
var _hoisted_8 = {
  class: "countdown-wrap"
};
var _hoisted_9 = {
  class: "countdown-tips"
};
var _hoisted_10 = {
  class: "how-to-get absolute-center-x"
};
var _hoisted_11 = {
  class: "how-to-get-steps"
};
var _hoisted_12 = {
  class: "step-item"
};
var _hoisted_13 = {
  class: "step-item-text"
};
var _hoisted_14 = {
  class: "step-item"
};
var _hoisted_15 = {
  class: "step-item-text"
};
var _hoisted_16 = {
  class: "step-item"
};
var _hoisted_17 = {
  class: "step-item-text"
};
var _hoisted_18 = {
  class: "invite-info absolute-center-x"
};
var _hoisted_19 = {
  class: "receive-record"
};
var _hoisted_20 = {
  class: "record-list"
};
var _hoisted_21 = {
  class: "assist-name"
};
var _hoisted_22 = {
  class: "assist-time"
};
var _hoisted_23 = {
  class: "share-now-btn-wrap"
};
var _hoisted_24 = {
  key: 1,
  class: "go-to-use"
};
var _hoisted_25 = {
  class: "flex justify-center"
};
var _hoisted_26 = {
  class: "icon-close-wrap absolute-center"
};
import { ref, onMounted, computed, onBeforeUnmount } from "vue";
import Dialog from "@/components/activity/Dialog.vue";
import CouponPrice from "@/components/activity/CouponPrice.vue";
import { CountDown } from "vant";
import SectionTitle from "@/components/activity/SectionTitle.vue";
import SvgIcon from "@/components/base/SvgIcon.vue";
import ShareButton from "@/components/activity/ShareButton.vue";
import ShareCouponInfo from "@/components/activity/ShareCouponInfo.vue";
import { Popup } from "vant";
import { ActivityStatusEnum } from "@/constant/activity";
import { useRouter } from "@/hooks/useRouter";
import { isLogin } from "@/utils/authUtil";
import { showLoading, hideLoading } from "@/utils/loadingUtil";
import { getSharingUserActivityInfo } from "@/api/activity";
import { UserActivityStatusEnum } from "@/constant/activity";
import { formatDateWithTZ } from "@/utils/format";
import { createSharingUserActivity } from "@/api/activity";
import { useShare } from "@/hooks/useShare";
import SharePopup from "@/components/SharePopup.vue";
import { getSupplyId, getUserId } from "@/utils/authUtil";
import { useShopStore } from "@/store/shopStore";
import { useSupplierStore } from "@/store/supplierStore";
import { ACTIVITY_REACH_MAX_PARTICIPATOR } from "@/constant/responseCode";
import { addQueryString } from "@/utils/tools";
import LoopSwipe from "@/components/activity/LoopSwipe.vue";
import ProgressBar from "@/components/activity/ProgressBar.vue";
import { showToast } from "@/utils/toastUtil";
import { askPushSubscription } from "@/utils/PushSubscriptionUtil";
import { Login } from "@/components/login/LoginDialog";
import { useI18n } from "vue-i18n";
export default {
  __name: 'SharingSharer',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var shopStore = useShopStore();
    var supplierStore = useSupplierStore();
    var activityInfo = ref(window.__ACTIVITY_INFO__);
    var userActivityInfo = ref(null);
    var _useShare = useShare(),
      showSharePopup = _useShare.showSharePopup,
      shareText = _useShare.shareText,
      shareLink = _useShare.shareLink,
      toShare = _useShare.toShare;
    var sharerRewardCoupon = computed(function () {
      return activityInfo.value.sharer_reward_coupon;
    });
    var userActivityStatus = computed(function () {
      var _userActivityInfo$val;
      return ((_userActivityInfo$val = userActivityInfo.value) === null || _userActivityInfo$val === void 0 ? void 0 : _userActivityInfo$val.user_activity_status) || UserActivityStatusEnum.INIT;
    });
    var backgroundSrc = computed(function () {
      if (showBackgroundSrc.value) {
        if (userActivityInfo.value) {
          return activityInfo.value.active_page_background || "";
        } else {
          return activityInfo.value.loading_page_background || "";
        }
      } else {
        return "";
      }
    });
    var canCreateActivity = computed(function () {
      return activityInfo.value.activity_status === ActivityStatusEnum.ONGOING && activityInfo.value.current_participated_count < activityInfo.value.max_participated_count;
    });
    var shareBtnText = computed(function () {
      if (userActivityStatus.value === UserActivityStatusEnum.ONGOING) {
        return t("shareNow");
      } else {
        return t("shareAgain");
      }
    });
    var countdownTips = computed(function () {
      var tipsMap = _defineProperty(_defineProperty(_defineProperty({}, UserActivityStatusEnum.ONGOING, t("theCouponWillExpire")), UserActivityStatusEnum.ENDED, t("theCouponhadExpired")), UserActivityStatusEnum.DONE, t("voucherArrived"));
      return tipsMap[userActivityStatus.value] || "";
    });
    var activityEndCountdown = computed(function () {
      var _userActivityInfo$val2;
      return ((_userActivityInfo$val2 = userActivityInfo.value) === null || _userActivityInfo$val2 === void 0 ? void 0 : _userActivityInfo$val2.user_activity_end_time) >= 0 && userActivityStatus.value !== UserActivityStatusEnum.DONE ? userActivityInfo.value.user_activity_end_time : 0;
    });
    var assitorInfoList = computed(function () {
      var _userActivityInfo$val3;
      return ((_userActivityInfo$val3 = userActivityInfo.value) === null || _userActivityInfo$val3 === void 0 ? void 0 : _userActivityInfo$val3.assitor_info) || [];
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isLogin()) {
              loadSharingUserActivityInfo();
            } else {
              showBackgroundSrc.value = true;
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var hasPushState = ref(false);
    var showBackgroundSrc = ref(false);
    // 查询用户是否有已发起的活动
    function loadSharingUserActivityInfo() {
      return _loadSharingUserActivityInfo.apply(this, arguments);
    } // 未登录状态下点击go to use按钮
    function _loadSharingUserActivityInfo() {
      _loadSharingUserActivityInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var showPopup,
          res,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              showPopup = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;
              showLoading();
              _context2.next = 4;
              return getSharingUserActivityInfo({
                activity_id: activityInfo.value.activity_id,
                user_activity_id: activityInfo.value.user_activity_id
              });
            case 4:
              res = _context2.sent;
              if (res.isOK) {
                if (res.data.user_activity_status === UserActivityStatusEnum.INIT) {
                  if (!canCreateActivity.value) {
                    isWarnDialogVisible.value = true;
                  }
                } else {
                  userActivityInfo.value = res.data;
                  if (res.data.user_activity_status === UserActivityStatusEnum.DONE && showPopup) {
                    setTimeout(function () {
                      openGotoUsePopup();
                    }, 1000);
                  } else if (res.data.user_activity_status === UserActivityStatusEnum.ONGOING) {
                    pushState();
                  }
                }
              }
              hideLoading();
              showBackgroundSrc.value = true;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _loadSharingUserActivityInfo.apply(this, arguments);
    }
    function handleCreateUserActivity() {
      return _handleCreateUserActivity.apply(this, arguments);
    } // 发起用户活动
    function _handleCreateUserActivity() {
      _handleCreateUserActivity = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (isLogin()) {
                createUserActivity();
              } else {
                Login.open({
                  onSuccess: function onSuccess() {
                    loadSharingUserActivityInfo();
                  }
                });
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _handleCreateUserActivity.apply(this, arguments);
    }
    function createUserActivity() {
      return _createUserActivity.apply(this, arguments);
    } // 分享活动
    function _createUserActivity() {
      _createUserActivity = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return createSharingUserActivity({
                activity_id: activityInfo.value.activity_id,
                activity_url_host: window.location.origin
              });
            case 2:
              res = _context4.sent;
              if (res.isOK) {
                showToast(t("success"), 1000);
                setTimeout(function () {
                  userActivityInfo.value = res.data;
                  if (res.data.user_activity_status === UserActivityStatusEnum.ONGOING) {
                    pushState();
                  }
                }, 1000);
              } else if (res.code === ACTIVITY_REACH_MAX_PARTICIPATOR) {
                showToast(t("participateTimeLimited"));
              } else {
                showToast(t("theActivityHasEnded"));
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _createUserActivity.apply(this, arguments);
    }
    function handleShare() {
      if (userActivityStatus.value === UserActivityStatusEnum.ONGOING) {
        var _userActivityInfo$val4;
        toShare(shopStore.getShopName, t("clickToParticipate"), ((_userActivityInfo$val4 = userActivityInfo.value) === null || _userActivityInfo$val4 === void 0 ? void 0 : _userActivityInfo$val4.sharer_activity_url) || "".concat(window.location.origin, "/activity/").concat(getSupplyId(), "/invite?id=").concat(activityInfo.value.activity_id, "&user_id=").concat(getUserId()));
      } else {
        createUserActivity();
      }
    }
    // 使用已到账的优惠券
    function handleUseCoupon() {
      return _handleUseCoupon.apply(this, arguments);
    } // 离开询问，继续活动
    function _handleUseCoupon() {
      _handleUseCoupon = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!supplierStore.getWhatsappid) {
                _context5.next = 4;
                break;
              }
              location.href = "https://wa.me/".concat(supplierStore.getWhatsappid, "/?text=").concat(encodeURIComponent(t("wantToUseMyVoucher")));
              _context5.next = 7;
              break;
            case 4:
              _context5.next = 6;
              return askPushSubscription();
            case 6:
              routerPush({
                name: "MyCouponList"
              });
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return _handleUseCoupon.apply(this, arguments);
    }
    function handleGoON() {
      isleaveTipsDialogVisible.value = false;
      pushState();
    }
    // 离开询问，放弃活动
    function handleGiveup() {
      isleaveTipsDialogVisible.value = false;
      history.back();
    }
    var isWarnDialogVisible = ref(false);
    var isleaveTipsDialogVisible = ref(false);
    var isGoToUsePopupVisible = ref(false);
    var shareCouponInfoWrap = ref();
    var gotoUsePopupHeight = ref(0);
    function openGotoUsePopup() {
      if (userActivityStatus.value === UserActivityStatusEnum.DONE) {
        isGoToUsePopupVisible.value = true;
        setTimeout(function () {
          if (shareCouponInfoWrap.value) {
            gotoUsePopupHeight.value = shareCouponInfoWrap.value.offsetHeight;
          }
        }, 100);
      }
    }
    function handleGoHome() {
      routerPush({
        name: "Index"
      });
    }
    function pushState() {
      if (!hasPushState.value) {
        hasPushState.value = true;
        history.pushState({}, "", addQueryString(location.href, "beforeleave=1"));
      }
    }
    function onPopstate() {
      if (hasPushState.value) {
        hasPushState.value = false;
        isleaveTipsDialogVisible.value = true;
      }
    }
    onMounted(function () {
      window.addEventListener("popstate", onPopstate);
    });
    onBeforeUnmount(function () {
      window.removeEventListener("popstate", onPopstate);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[10] || (_cache[10] = _createElementVNode("img", {
        src: _imports_0,
        class: "asset-preload"
      }, null, -1)), _createElementVNode("div", {
        class: "activity-sharing-main",
        style: _normalizeStyle({
          'background-image': backgroundSrc.value ? "url(".concat(backgroundSrc.value, ")") : ''
        })
      }, [userActivityInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[9] || (_cache[9] = _createElementVNode("img", {
        src: _imports_0,
        class: "content-wrap-bg"
      }, null, -1)), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("shareToGetVouchers")), 1), _createElementVNode("div", {
        class: "coupon-info absolute-center-x",
        onClick: openGotoUsePopup
      }, [_createElementVNode("div", _hoisted_6, [_createVNode(CouponPrice, {
        "discount-type": sharerRewardCoupon.value.discount_type,
        "discount-rule": sharerRewardCoupon.value.discount_rule,
        disabled: userActivityStatus.value === _unref(UserActivityStatusEnum).ENDED
      }, null, 8, ["discount-type", "discount-rule", "disabled"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_unref(CountDown), {
        class: _normalizeClass(["countdown", {
          'countdown--grey': activityEndCountdown.value === 0
        }]),
        time: activityEndCountdown.value,
        onFinish: _cache[0] || (_cache[0] = function ($event) {
          return loadSharingUserActivityInfo(false);
        })
      }, null, 8, ["class", "time"])]), _createElementVNode("div", _hoisted_9, _toDisplayString(countdownTips.value), 1)])]), _createElementVNode("div", _hoisted_10, [_createVNode(SectionTitle, {
        title: _unref(t)('howtoGet')
      }, null, 8, ["title"]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[6] || (_cache[6] = _createElementVNode("img", {
        class: "step-item-icon",
        src: _imports_1,
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("shareThisPageToFriends")), 1)]), _createVNode(SvgIcon, {
        class: "step-arrow",
        name: "step_arrow"
      }), _createElementVNode("div", _hoisted_14, [_cache[7] || (_cache[7] = _createElementVNode("img", {
        class: "step-item-icon",
        src: _imports_2,
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("friendsReceiveVouchers")), 1)]), _createVNode(SvgIcon, {
        class: "step-arrow",
        name: "step_arrow"
      }), _createElementVNode("div", _hoisted_16, [_cache[8] || (_cache[8] = _createElementVNode("img", {
        class: "step-item-icon",
        src: _imports_3,
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("youCanAlsoGetVouchers")), 1)])])]), _createElementVNode("div", _hoisted_18, [_createVNode(SectionTitle, {
        title: _ctx.$t('youNeedInviteNFriends', [userActivityInfo.value.assist_min_count])
      }, null, 8, ["title"]), _createVNode(ProgressBar, {
        "assist-min-count": userActivityInfo.value.assist_min_count,
        "assisted-count": assitorInfoList.value.length
      }, null, 8, ["assist-min-count", "assisted-count"])])]), _createElementVNode("div", _hoisted_19, [_createVNode(SectionTitle, {
        title: _ctx.$t('voucherRecords')
      }, null, 8, ["title"]), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assitorInfoList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.user_id,
          class: "record-item"
        }, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("nReceivedTheVoucher", [item.nickname])), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(formatDateWithTZ)(item.assist_time)), 1)]);
      }), 128))])])]), _createElementVNode("div", _hoisted_23, [_createVNode(ShareButton, {
        class: "share-now-btn",
        text: shareBtnText.value,
        "show-breath-animation": "",
        onClick: handleShare
      }, null, 8, ["text"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(ShareCouponInfo, {
        title: activityInfo.value.loading_page_desc,
        "button-text": _ctx.$t('goToUse'),
        "discount-type": sharerRewardCoupon.value.discount_type,
        "discount-rule": sharerRewardCoupon.value.discount_rule,
        onClickButton: handleCreateUserActivity
      }, null, 8, ["title", "button-text", "discount-type", "discount-rule"])])]))], 4), _createVNode(LoopSwipe), _createVNode(Dialog, {
        visible: isWarnDialogVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return isWarnDialogVisible.value = $event;
        }),
        title: _ctx.$t('theActivityHasEnded'),
        "ok-text": _ctx.$t('getMoreVouchers'),
        "without-cancel": true,
        "close-on-click-overlay": false,
        "on-ok": handleGoHome
      }, null, 8, ["visible", "title", "ok-text"]), _createVNode(Dialog, {
        visible: isleaveTipsDialogVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
          return isleaveTipsDialogVisible.value = $event;
        }),
        title: _ctx.$t('activityCompletedDesc'),
        "ok-text": _ctx.$t('goOn'),
        "cancel-text": _ctx.$t('giveUp'),
        "on-ok": handleGoON,
        "on-cancel": handleGiveup
      }, null, 8, ["visible", "title", "ok-text", "cancel-text"]), _createVNode(_unref(Popup), {
        show: isGoToUsePopupVisible.value,
        "onUpdate:show": _cache[4] || (_cache[4] = function ($event) {
          return isGoToUsePopupVisible.value = $event;
        }),
        round: "",
        "lazy-render": false,
        "close-on-click-overlay": false
      }, {
        "overlay-content": _withCtx(function () {
          return [_withDirectives(_createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
            style: _normalizeStyle({
              height: gotoUsePopupHeight.value + 'px'
            })
          }, null, 4), _createVNode(SvgIcon, {
            class: "icon-close absolute-center-x",
            name: "close_btn ",
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return isGoToUsePopupVisible.value = false;
            })
          })], 512), [[_vShow, gotoUsePopupHeight.value]])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            ref_key: "shareCouponInfoWrap",
            ref: shareCouponInfoWrap
          }, [_createVNode(ShareCouponInfo, {
            title: _ctx.$t('getVoucherXToUse', [sharerRewardCoupon.value.title]),
            "button-text": _ctx.$t('goToUse'),
            "discount-type": sharerRewardCoupon.value.discount_type,
            "discount-rule": sharerRewardCoupon.value.discount_rule,
            onClickButton: handleUseCoupon
          }, null, 8, ["title", "button-text", "discount-type", "discount-rule"])], 512)];
        }),
        _: 1
      }, 8, ["show"]), _createVNode(SharePopup, {
        show: _unref(showSharePopup),
        "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
          return _isRef(showSharePopup) ? showSharePopup.value = $event : null;
        }),
        text: _unref(shareText),
        link: _unref(shareLink)
      }, null, 8, ["show", "text", "link"])]);
    };
  }
};